<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>NOUVEAU VÉHICULE</span>
        </div>
        <div class="small-modal__body">
          <!--registration_number-->
          <div class="small-modal__body__block" :class="{
            'w-500': existingVehicleFound,
          }">
            <div class="small-modal__body__block--title required text-capitalize">
              <span>Immatriculation</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input" :class="{
                'input-addon': existingVehicleFound || isVehicleSearching,
              }">
                <the-mask :mask="['SS-###-SS']" v-model="vehicle.registration_number" @input="searchByRegNumber"
                  :masked="true" style="text-transform: uppercase" />

                <div class="small-modal__body__block__content--input--loader" v-if="isVehicleSearching">
                  <Preloader :wrapper-height="'20px'" :size="'20px'" />
                </div>

                <!-- <button
                  type="button"
                  @click.prevent="fillTheFieldsByImmatriculation"
                  class="form_bt form_confirm_button form__item__submit__button--small-helper"
                  style="height: 28px"
                  v-if="existingVehicleFound && !isVehicleSearching"
                >
                  Compléter
                </button> -->
              </div>
            </div>
          </div>
          <!--car_brand-->
          <div class="small-modal__body__block">
            <div class="small-modal__body__block--title text-capitalize required">
              <span>Marque</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                <input v-model="vehicle.car_brand" />
              </div>
            </div>
          </div>
          <!--car_model-->
          <div class="small-modal__body__block">
            <div class="small-modal__body__block--title text-capitalize required">
              <span>Modèle</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                <input v-model="vehicle.car_model" />
              </div>
            </div>
          </div>
          <!--car_circulationDate-->
          <div class="small-modal__body__block">
            <div class="small-modal__body__block--title text-capitalize required">
              <span>Date De 1ère Mise En Circulation</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                <the-mask v-model="circulationDateInput" :mask="['##/##/####']" />
              </div>
            </div>
          </div>
          <!--car_serial_number-->
          <div class="small-modal__body__block">
            <div class="small-modal__body__block--title text-capitalize required">
              <span>Numéro De Série</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                <input v-model="vehicle.car_serial_number" />
              </div>
            </div>
          </div>
          <!--entry_date-->
          <div class="small-modal__body__block">
            <div class="small-modal__body__block--title text-capitalize required">
              <span>Date Entrée Parc</span>
            </div>
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                <vue-datepicker-local v-model="vehicle.entry_date" :format="$store.getters.getDateFormat"
                  :local="datepicker_default_local[$store.state.locale]"></vue-datepicker-local>
              </div>
            </div>
          </div>
        </div>
        <div class="small-modal__footer">
          <div class="small-modal__footer__actions d-flex justify-content-between">
            <button class="blue-button" @click.prevent="$emit('close')">
              <span>FERMER</span>
            </button>
            <button class="green-button" @click.prevent="create">
              <span>CRÉER</span>
            </button>
          </div>
        </div>
      </div>
      <ErrorModal v-if="isErrorPopup" @close="isErrorPopup = false" :error="ErrorMessage" />
    </div>
  </transition>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { DEBOUNCE } from "@/mixins/helper";
import garantieFieldsLists from "@/mixins/garantieFieldsLists";
import VueDatepickerLocal from "@/components/VueDatepickerLocal";
import datepickerLocalization from "@/mixins/datepickerLocalization";
import { TheMask } from "vue-the-mask";
import Preloader from "@/components/Preloader";
import ErrorModal from "@/components/GarantiesSouscrites/ErrorModal";

export default {
  name: "AddVehicleModal",
  mixins: [datepickerLocalization, validationMixin, garantieFieldsLists],
  components: { TheMask, Preloader, VueDatepickerLocal, ErrorModal },
  data() {
    return {
      vehicle: {
        registration_number: null,
        car_brand: null,
        car_model: null,
        car_serial_number: null,
        carburant: null,
        cylindree: null,
        type_vehicule: null,
        puis_fisc: null,
        entry_date: new Date(),
        jour_mise_en_circulation: "",
        mois_mise_en_circulation: "",
        annee_mise_en_circulation: "",
      },
      isVehicleSearching: false,
      searchVehicleResult: null,
      circulationDateInput: "",
      isErrorPopup: false,
      ErrorMessage: null,
    };
  },
  computed: {
    mutuaideAssistanceId() {
      return this.$route.params.id;
    },
    existingVehicleFound() {
      return !!this.searchVehicleResult;
    },
  },
  methods: {
    searchByRegNumber: DEBOUNCE(function (val) {
      // alert('here');
      this.vehicle.registration_number =
        this.vehicle.registration_number.toUpperCase();

      let matched = this.vehicle.registration_number.match(
        /(^([A-Z]{2}-[0-9]{3}-[A-Z]{2})+$)|(^([0-9]{3}-[A-Z]{3}-[0-9]{2})+$)/g
      );

      if (matched) {
        let url = "client/registration",
          data = {
            regNumber: this.vehicle.registration_number,
          };
        this.isVehicleSearching = true;
        this.apiPost(url, data, false)
          .then((response) => {
            if (response.data.info) {
              this.searchVehicleResult = response.data.info;
              this.parseVehicleInfo(this.searchVehicleResult);
            }
            this.isVehicleSearching = false;
          })
          .catch((error) => {
            this.showErrorNotification(error);
            this.isVehicleSearching = false;
          });
      }
    }, 1000),
    fillTheFieldsByImmatriculation() {
      if (this.searchVehicleResult) {
        this.parseVehicleInfo(this.searchVehicleResult);
        // this.searchVehicleResult = null;
      }
    },
    parseVehicleInfo(info) {
      /* Car brand */
      if (info.Marque) {
        this.vehicle.car_brand = info.Marque.split(".").join("");
      }

      /* Modele */
      this.vehicle.car_model = info.Modele
        ? info.Modele.toLocaleString()
        : null;
      /* Num serie */
      this.vehicle.car_serial_number = info.VIN ? info.VIN : null;

      /* CARBUTANT */
      if (info.Energie) {
        //GAZ+ELEC => HYBRIDE
        let carburantFromApi = info.Energie.toString();
        if (carburantFromApi.toLowerCase().match(/gaz\+elec/)) {
          info.Energie = "Hybride";
          this.vehicle.carburant = 5;
        } else {
          if (info.Energie === "GAZOLE") info.Energie = "Diesel";
          if (carburantFromApi.toUpperCase().includes("GAZOG")) info.Energie = "ESS+G.P.L.";

          let founded = this.list_type_car_carburant.findIndex((item) => {
            return item.toUpperCase() === info.Energie.toUpperCase();
          });

          if (founded > 0) {
            this.vehicle.carburant = founded;
          }
        }
      }

      /* Cylindree */
      if (info.Cylindree) {
        let cylindree = +info.Cylindree;

        if (cylindree > 3500) {
          this.vehicle.cylindree = 3;
        } else if (cylindree >= 2500 && cylindree <= 3500) {
          this.vehicle.cylindree = 2;
        } else if (cylindree < 2500) {
          this.vehicle.cylindree = 1;
        }
      }

      /* Car type */
      let genre = info.Genre ? info.Genre.toUpperCase() : undefined,
        genreCG = info.GenreCG ? info.GenreCG.toUpperCase() : undefined,
        propulsion = info.Propulsion
          ? info.Propulsion.toUpperCase()
          : undefined;

      if (genre === "CTTE" || genreCG === "CTTE") {
        this.vehicle.type_vehicule = 5;
      } else if (propulsion === "AVANT" || propulsion === "ARRIERE") {
        this.vehicle.type_vehicule = 4;
      } else if (genre === "VP" || genreCG === "VP") {
        this.vehicle.type_vehicule = 4;
      } else if (genre === "VU" || genreCG === "VU") {
        this.vehicle.type_vehicule = 5;
      } else this.vehicle.type_vehicule = 4;

      if (info.PuissFisc) {
        this.vehicle.puis_fisc = +info.PuissFisc;
      }

      if (info.DateMec) {
        this.circulationDateInput = this.moment(info.DateMec).format(
          "DDMMYYYY"
        );
        let date = this.circulationDateInput,
          currentYear = new Date().getFullYear();
        if (date.length < 8) {
          this.resetCirculationDate();
          return false;
        }
        let day = date.substr(0, 2),
          month = date.substr(2, 2),
          year = date.substr(4, 4);

        if (
          day < 0 ||
          day > 31 ||
          month < 0 ||
          month > 12 ||
          year > currentYear
        ) {
          this.resetCirculationDate();
          return false;
        }

        this.vehicle.jour_mise_en_circulation = +day;
        this.vehicle.mois_mise_en_circulation = +month;
        this.vehicle.annee_mise_en_circulation = +year;
      }
    },
    resetCirculationDate() {
      this.vehicle.jour_mise_en_circulation = "";
      this.vehicle.mois_mise_en_circulation = "";
      this.vehicle.annee_mise_en_circulation = "";
    },
    create() {
      let url = `mutuaide/assistance-car`,
        data = {
          ...this.vehicle,
          mutuaide_assistance_id: this.mutuaideAssistanceId,
          from_partner: true
        };
      data.entry_date = this.moment(this.vehicle.entry_date).format(
        "YYYY-MM-DD 00:00:00"
      );
      if (data.registration_number) {
        data.registration_number = data.registration_number.toUpperCase();
      }

      if (this.circulationDateInput && this.circulationDateInput.length >= 8) {
        let dateStr = this.circulationDateInput.replace(/\D/g, ''); // Ensure only numbers
        if (dateStr.length === 8) {
          data.jour_mise_en_circulation = +dateStr.substr(0, 2);
          data.mois_mise_en_circulation = +dateStr.substr(2, 2);
          data.annee_mise_en_circulation = +dateStr.substr(4, 4);
        }
      }

      if (!this.$v.$invalid) {
        console.log(data);
        this.apiPost(url, data)
          .then((response) => {
            console.log(response.data);
            this.showSuccessNotification("Le véhicule a été ajouté au parc.");
            this.$emit("close");
            this.$emit("update-list");
          })
          .catch((error) => {
            this.isErrorPopup = true;
            this.ErrorMessage = error.response.data.message;
          });
      } else {
        this.showWarningNotification("Please fill all required fields.");
      }
    },
  },
  validations: {
    vehicle: {
      registration_number: {
        required,
      },
      car_brand: {
        required,
      },
      car_model: {
        required,
      },
      entry_date: {
        required,
      },
    },
  },
};
</script>
<style scoped>
.w-500 {
  width: 524px;
}
</style>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/AddVehicleModal.vue